import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'elv-clock',
  template: `<span>{{clock | date:'EEEE d MMMM y, HH:mm:ss'}}</span>`,
  styleUrls: ['./clock.component.scss'],
})
export class ClockComponent {

  clock: Date = new Date();

  constructor() {
    setInterval(() => {
      this.clock = new Date();
    }, 1000);
  }

}
